export default __webpack_public_path__ + "static/media/illustrator.6e9aa83c.svg";